import ProxyBase from '../../../../../core/proxies/ProxyBase'

class Proxy extends ProxyBase {
  getTransactionStatus(params) {
    return this.get('Transaction/TransactionStatus', params)
  }
  getOrderStatus(params) {
    return this.get('CartAndOrder/OrderStatus', params)
  }
  getListOrders(params) {
    return this.get('CartAndOrder/Orders/Paged', params)
  }
  postNewTransactionOrders(params) {
    return this.post('CartAndOrder/Orders/NewTransaction', params)
  }
}

const proxy = new Proxy()
export default proxy
